import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Col, FormGroup, Form, Input, Label, Row, Table} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {formatarReal, formatarValorReal} from "../../../../utils/formatar";
import NumberFormat from "react-number-format";
import moment from "moment/moment";

@inject("store")
@observer
export class RateioProdutos extends Component {

    static propTypes = {
        controller: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.controller = this.props.controller;
    }

    render() {
        const rateio = [];

        this.controller.alocacoesProduto.map((alocacao, index) => {
            rateio.push(<tr key={index}>
                <td>{alocacao.produto}</td>
                <td>{alocacao.atividade}</td>
                <td>{alocacao.numeroARDebito}</td>
                <td>{alocacao.percentualAlocacao ? alocacao.percentualAlocacao + "%" : ""}</td>
            </tr>)
        });
        return (
            <div>
                <h4>Rateio</h4>
                <Table bordered className="read-only" style={{backgroundColor: "#eceeef"}}>
                    <thead>
                    <tr>
                        <th>Produto</th>
                        <th>Projeto/centro de resultado/finalidade</th>
                        <th>Número centro de custo débito</th>
                        <th>%</th>
                    </tr>
                    </thead>
                    <tbody>
                    {rateio}
                    </tbody>
                </Table>
            </div>
        )
    }
}